import { css } from 'styled-components';

export const toastrStyle = css`
  border-radius: 5px;
  font-size: 2rem;
  font-weight: normal;
  position: fixed;
  top: 5px;
  right: 5px;
  z-index: 9999999999999;
  border: 0;
  color: #ffffff;
    .toastr {
      position: absolute;
      top: 0;
      width: 100%;
      display: flex;
      align-items: center;
      padding-left: 40px;
        .toastr-status {
              width: 100%;
              height: 5px;

              &.success {
                background-color: #5cb85c;
              }

              &.error {
                background-color: #d9534f;
              }
            }

      &:before {
        content: '';
        height: 70px;
      }
`;
